var map = {
	"./armchair/colorful.svg": 6881,
	"./armchair/monochrome.svg": 92272,
	"./ball/colorful.svg": 14075,
	"./ball/monochrome.svg": 36838,
	"./ballet_shoe/colorful.svg": 94678,
	"./ballet_shoe/monochrome.svg": 44931,
	"./balloons/colorful.svg": 74850,
	"./balloons/monochrome.svg": 99015,
	"./banknotes/colorful.svg": 50795,
	"./banknotes/monochrome.svg": 67510,
	"./beach_ball/colorful.svg": 16639,
	"./beach_ball/monochrome.svg": 61650,
	"./beer/colorful.svg": 49672,
	"./beer/monochrome.svg": 87537,
	"./beer_mug/colorful.svg": 68140,
	"./beer_mug/monochrome.svg": 29885,
	"./bell/colorful.svg": 18479,
	"./bell/monochrome.svg": 20130,
	"./biceps/colorful.svg": 7766,
	"./biceps/monochrome.svg": 24707,
	"./bicycle/colorful.svg": 50485,
	"./bicycle/monochrome.svg": 22780,
	"./book/colorful.svg": 27811,
	"./book/monochrome.svg": 10718,
	"./bookshelf/colorful.svg": 19747,
	"./bookshelf/monochrome.svg": 47614,
	"./brain/colorful.svg": 76668,
	"./brain/monochrome.svg": 72461,
	"./brush/colorful.svg": 27188,
	"./brush/monochrome.svg": 47925,
	"./bubble_tea/colorful.svg": 87185,
	"./bubble_tea/monochrome.svg": 90208,
	"./buttons/colorful.svg": 57893,
	"./buttons/monochrome.svg": 5132,
	"./cake/colorful.svg": 97786,
	"./cake/monochrome.svg": 40303,
	"./calendar/colorful.svg": 27300,
	"./calendar/monochrome.svg": 4005,
	"./camera/colorful.svg": 32961,
	"./camera/monochrome.svg": 13904,
	"./camper/colorful.svg": 86428,
	"./camper/monochrome.svg": 52685,
	"./candle/colorful.svg": 14483,
	"./candle/monochrome.svg": 82894,
	"./car/colorful.svg": 66390,
	"./car/monochrome.svg": 48131,
	"./carrot/colorful.svg": 27757,
	"./carrot/monochrome.svg": 88324,
	"./carrots/colorful.svg": 46356,
	"./carrots/monochrome.svg": 99221,
	"./chart/colorful.svg": 7328,
	"./chart/monochrome.svg": 66841,
	"./chart_2/colorful.svg": 85473,
	"./chart_2/monochrome.svg": 9104,
	"./chemex/colorful.svg": 25518,
	"./chemex/monochrome.svg": 94251,
	"./clapperboard/colorful.svg": 26369,
	"./clapperboard/monochrome.svg": 41392,
	"./coffee/colorful.svg": 37202,
	"./coffee/monochrome.svg": 78071,
	"./coffee_2/colorful.svg": 18603,
	"./coffee_2/monochrome.svg": 49174,
	"./coins/colorful.svg": 8098,
	"./coins/monochrome.svg": 88679,
	"./computer/colorful.svg": 6679,
	"./computer/monochrome.svg": 89338,
	"./cookie/colorful.svg": 32072,
	"./cookie/monochrome.svg": 74961,
	"./crochet_hook/colorful.svg": 22808,
	"./crochet_hook/monochrome.svg": 6593,
	"./cup/colorful.svg": 84576,
	"./cup/monochrome.svg": 70521,
	"./cupcake/colorful.svg": 22268,
	"./cupcake/monochrome.svg": 92173,
	"./diamond/colorful.svg": 8148,
	"./diamond/monochrome.svg": 4661,
	"./dice/colorful.svg": 38845,
	"./dice/monochrome.svg": 64244,
	"./disco_ball/colorful.svg": 42552,
	"./disco_ball/monochrome.svg": 11585,
	"./donut/colorful.svg": 99396,
	"./donut/monochrome.svg": 9125,
	"./door/colorful.svg": 70902,
	"./door/monochrome.svg": 37411,
	"./dress/colorful.svg": 36635,
	"./dress/monochrome.svg": 80134,
	"./dropper/colorful.svg": 748,
	"./dropper/monochrome.svg": 99069,
	"./dumbbells/colorful.svg": 81922,
	"./dumbbells/monochrome.svg": 30951,
	"./dumplings/colorful.svg": 64199,
	"./dumplings/monochrome.svg": 65354,
	"./eco_bag/colorful.svg": 50920,
	"./eco_bag/monochrome.svg": 81041,
	"./embroidery/colorful.svg": 67606,
	"./embroidery/monochrome.svg": 32867,
	"./eyebrows_and_eyelashes/colorful.svg": 45626,
	"./eyebrows_and_eyelashes/monochrome.svg": 23215,
	"./feather/colorful.svg": 35855,
	"./feather/monochrome.svg": 75234,
	"./feather_2/colorful.svg": 10986,
	"./feather_2/monochrome.svg": 55935,
	"./film/colorful.svg": 71776,
	"./film/monochrome.svg": 13913,
	"./film_roll/colorful.svg": 71380,
	"./film_roll/monochrome.svg": 59893,
	"./fire/colorful.svg": 27098,
	"./fire/monochrome.svg": 65711,
	"./fishing_rod/colorful.svg": 39688,
	"./fishing_rod/monochrome.svg": 21233,
	"./fitness/colorful.svg": 65796,
	"./fitness/monochrome.svg": 35205,
	"./flowers/colorful.svg": 120,
	"./flowers/monochrome.svg": 74145,
	"./fortune_cookie/colorful.svg": 48674,
	"./fortune_cookie/monochrome.svg": 52327,
	"./frying_pan/colorful.svg": 85879,
	"./frying_pan/monochrome.svg": 95738,
	"./frying_pan_2/colorful.svg": 33602,
	"./frying_pan_2/monochrome.svg": 36839,
	"./gameboy/colorful.svg": 67980,
	"./gameboy/monochrome.svg": 82122,
	"./gamepad/colorful.svg": 3667,
	"./gamepad/monochrome.svg": 40782,
	"./gift/colorful.svg": 41832,
	"./gift/monochrome.svg": 55057,
	"./glasses_3d/colorful.svg": 61508,
	"./glasses_3d/monochrome.svg": 32133,
	"./glasses_3d_2/colorful.svg": 14973,
	"./glasses_3d_2/monochrome.svg": 37780,
	"./graduation_cap/colorful.svg": 41645,
	"./graduation_cap/monochrome.svg": 56388,
	"./handmade/colorful.svg": 96634,
	"./handmade/monochrome.svg": 69359,
	"./headphones/colorful.svg": 43445,
	"./headphones/monochrome.svg": 76732,
	"./headphones_2/colorful.svg": 59488,
	"./headphones_2/monochrome.svg": 87609,
	"./heart/colorful.svg": 91692,
	"./heart/monochrome.svg": 23389,
	"./heel/colorful.svg": 3632,
	"./heel/monochrome.svg": 649,
	"./highlighter/colorful.svg": 99863,
	"./highlighter/monochrome.svg": 27290,
	"./house/colorful.svg": 4368,
	"./house/monochrome.svg": 12457,
	"./iced_latte/colorful.svg": 73174,
	"./iced_latte/monochrome.svg": 63299,
	"./kebab/colorful.svg": 62309,
	"./kebab/monochrome.svg": 96492,
	"./key/colorful.svg": 54255,
	"./key/monochrome.svg": 31650,
	"./knitting_needles/colorful.svg": 5417,
	"./knitting_needles/monochrome.svg": 84072,
	"./latte/colorful.svg": 84366,
	"./latte/monochrome.svg": 62091,
	"./lego/colorful.svg": 62235,
	"./lego/monochrome.svg": 95078,
	"./lightbulb/colorful.svg": 89247,
	"./lightbulb/monochrome.svg": 87922,
	"./lip_gloss/colorful.svg": 44280,
	"./lip_gloss/monochrome.svg": 43393,
	"./little_balloon/colorful.svg": 50562,
	"./little_balloon/monochrome.svg": 20935,
	"./little_cloud/colorful.svg": 92828,
	"./little_cloud/monochrome.svg": 89741,
	"./little_flower/colorful.svg": 97314,
	"./little_flower/monochrome.svg": 9447,
	"./little_mouse/colorful.svg": 90846,
	"./little_mouse/monochrome.svg": 73147,
	"./lotus/colorful.svg": 85483,
	"./lotus/monochrome.svg": 42518,
	"./macrame/colorful.svg": 55044,
	"./macrame/monochrome.svg": 4357,
	"./maple_leaf/colorful.svg": 25120,
	"./maple_leaf/monochrome.svg": 72441,
	"./mascara/colorful.svg": 19078,
	"./mascara/monochrome.svg": 54899,
	"./megaphone/colorful.svg": 84602,
	"./megaphone/monochrome.svg": 87503,
	"./microphone/colorful.svg": 398,
	"./microphone/monochrome.svg": 72587,
	"./mountains/colorful.svg": 9352,
	"./mountains/monochrome.svg": 46385,
	"./music_notes/colorful.svg": 90253,
	"./music_notes/monochrome.svg": 37476,
	"./needle/colorful.svg": 32617,
	"./needle/monochrome.svg": 74792,
	"./needle_and_thread/colorful.svg": 92178,
	"./needle_and_thread/monochrome.svg": 35223,
	"./origami/colorful.svg": 3306,
	"./origami/monochrome.svg": 91103,
	"./painting_palette/colorful.svg": 43826,
	"./painting_palette/monochrome.svg": 71543,
	"./palm_tree/colorful.svg": 26697,
	"./palm_tree/monochrome.svg": 42920,
	"./pawns/colorful.svg": 80619,
	"./pawns/monochrome.svg": 33590,
	"./pen/colorful.svg": 44075,
	"./pen/monochrome.svg": 30486,
	"./pencil/colorful.svg": 18207,
	"./pencil/monochrome.svg": 78034,
	"./phone/colorful.svg": 14676,
	"./phone/monochrome.svg": 48469,
	"./photos/colorful.svg": 1943,
	"./photos/monochrome.svg": 5018,
	"./pin/colorful.svg": 71327,
	"./pin/monochrome.svg": 5810,
	"./pinwheel/colorful.svg": 9532,
	"./pinwheel/monochrome.svg": 6061,
	"./pizza/colorful.svg": 77850,
	"./pizza/monochrome.svg": 3183,
	"./plane/colorful.svg": 12534,
	"./plane/monochrome.svg": 99107,
	"./plane_tickets/colorful.svg": 16212,
	"./plane_tickets/monochrome.svg": 90485,
	"./plant/colorful.svg": 86421,
	"./plant/monochrome.svg": 12348,
	"./popcorn/colorful.svg": 4741,
	"./popcorn/monochrome.svg": 88364,
	"./profit/colorful.svg": 23412,
	"./profit/monochrome.svg": 48213,
	"./rabbit/colorful.svg": 98586,
	"./rabbit/monochrome.svg": 85871,
	"./racket/colorful.svg": 43104,
	"./racket/monochrome.svg": 83705,
	"./rattle/colorful.svg": 42276,
	"./rattle/monochrome.svg": 50661,
	"./recycling/colorful.svg": 52258,
	"./recycling/monochrome.svg": 65895,
	"./robot/colorful.svg": 70300,
	"./robot/monochrome.svg": 36397,
	"./rolling_pin/colorful.svg": 70741,
	"./rolling_pin/monochrome.svg": 40828,
	"./scissors/colorful.svg": 40789,
	"./scissors/monochrome.svg": 96988,
	"./screwdriver/colorful.svg": 37342,
	"./screwdriver/monochrome.svg": 78459,
	"./seedling/colorful.svg": 97263,
	"./seedling/monochrome.svg": 68386,
	"./server/colorful.svg": 52245,
	"./server/monochrome.svg": 53948,
	"./sewing/colorful.svg": 39053,
	"./sewing/monochrome.svg": 92804,
	"./sewing_machine/colorful.svg": 68075,
	"./sewing_machine/monochrome.svg": 58902,
	"./shoe/colorful.svg": 62781,
	"./shoe/monochrome.svg": 23988,
	"./shopping_bags/colorful.svg": 47446,
	"./shopping_bags/monochrome.svg": 3587,
	"./single_dumpling/colorful.svg": 66211,
	"./single_dumpling/monochrome.svg": 88126,
	"./skull/colorful.svg": 54161,
	"./skull/monochrome.svg": 63136,
	"./small_bottle/colorful.svg": 302,
	"./small_bottle/monochrome.svg": 93931,
	"./steering_wheel/colorful.svg": 96353,
	"./steering_wheel/monochrome.svg": 72912,
	"./surfboard/colorful.svg": 18644,
	"./surfboard/monochrome.svg": 28053,
	"./sushi/colorful.svg": 40514,
	"./sushi/monochrome.svg": 43431,
	"./sweets/colorful.svg": 25595,
	"./sweets/monochrome.svg": 37190,
	"./syringe/colorful.svg": 22565,
	"./syringe/monochrome.svg": 95948,
	"./tea/colorful.svg": 2166,
	"./tea/monochrome.svg": 32035,
	"./tea_bag/colorful.svg": 11351,
	"./tea_bag/monochrome.svg": 77498,
	"./tetris/colorful.svg": 58363,
	"./tetris/monochrome.svg": 96838,
	"./tetris_2/colorful.svg": 19294,
	"./tetris_2/monochrome.svg": 59771,
	"./threads/colorful.svg": 79669,
	"./threads/monochrome.svg": 3100,
	"./tie/colorful.svg": 59958,
	"./tie/monochrome.svg": 45923,
	"./tire/colorful.svg": 26744,
	"./tire/monochrome.svg": 63777,
	"./tree/colorful.svg": 8130,
	"./tree/monochrome.svg": 27975,
	"./umbrella/colorful.svg": 40646,
	"./umbrella/monochrome.svg": 58419,
	"./vinyl/colorful.svg": 96436,
	"./vinyl/monochrome.svg": 86965,
	"./wallet/colorful.svg": 74947,
	"./wallet/monochrome.svg": 56638,
	"./watch_fitness/colorful.svg": 50088,
	"./watch_fitness/monochrome.svg": 68881,
	"./wave/colorful.svg": 56911,
	"./wave/monochrome.svg": 55586,
	"./yarn/colorful.svg": 48999,
	"./yarn/monochrome.svg": 92853,
	"./yoga/colorful.svg": 80466,
	"./yoga/monochrome.svg": 71767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28187;